export const extractErrorDetail = async (res: Response): Promise<string | null> => {
    try {
        const data = await res.json()
        return typeof data?.detail === 'string' ? data.detail : null
    } catch {
        return null
    }
}

// 429 от лимитера бэкенда — показываем, сколько ждать, по заголовку Retry-After
export const getRateLimitMessage = (res: Response): string | null => {
    if (res.status !== 429) return null
    const seconds = Number(res.headers.get('Retry-After'))
    if (!seconds) return 'Слишком много попыток, попробуйте позже'
    return `Слишком много попыток, попробуйте через ${Math.ceil(seconds / 60)} мин.`
}
